export const STEP_INITIAL = 'initialData';
export const STEP_INCOMES = 'incomes';
export const STEP_OVERPAYMENTS = 'overpayments';
export const STEP_SUBMIT = 'submit';

export const STEP_INITIAL_FORM = `${STEP_INITIAL}Form`;
export const STEP_INCOMES_FORM = `${STEP_INCOMES}Form`;
export const STEP_OVERPAYMENTS_FORM = `${STEP_OVERPAYMENTS}Form`;

export const REPORT_YEAR = 2020;
